import React, { useEffect, useState } from "react";
import { Header } from "../components/ui/header";
import { money } from "../utilities/currency";
import axios from "axios";
import { Footer } from "../components/ui/footer";
type vilkarPageProps = {
    currentUser: any,
    onLogout: any,
    baseUrl: string,
    onLoginClick: any,
    onLoginSuccess: any,
}
const T = {
    offer: "✨ Spesialtilbud – Betal 99 kr, få 198 kr i ringe kreditt! ✨",
    signIn: "Logg inn",
    join: "Bli med",
    allAdvisors: "Alle veiledere",
    festivalTitle: "Festivalkampanjer",
    referTitle: "Verv & få gratis reading!",
    referBody: "Verv 5 betalende kunder og få en GRATIS 15‑min reading hos en toppveileder.",
    blogTitle: "Fra Mystic‑bloggen",
    viewAll: "Se alle",
    subscribeLine: "Få nye guider og tilbud på e‑post.",
    read: "Les",
    invite: "Inviter venner",
    sponsored: "Sponset",
    ad: (n: number) => `Annonse ${n}`,
    adBlurb: "Annonser produkter, apper eller arrangementer her.",
    learnMore: "Les mer",
    connectNow: "Koble til nå",
    from: "fra",
    minutes: "min",
    verified: "Verifisert",
    categories: [
        "Kjærlighetsreading",
        "Klarsynt reading",
        "Tarot‑reading",
        "Astrologi & Horoskop",
        "Englebudskap",
        "Orakel‑veiledning",
        "Drømmetydning",
        "Åndelig medium",
    ],
    hero: {
        name: "Klarsynte Eirik",
        tag: "Kjærlighetsekspert",
        blurb:
            "Mitt løfte: Jeg er her for deg. Når det er vanskelig å vite hvem man kan stole på, er ekte nærvær alt.",
        getReading: "Bestill reading",
    },
    footer: {
        getApp: "Få appen for klarhet hvor du enn er.",
        explore: "Utforsk",
        special: "Spesialiteter",
        more: "Mer",
        advisors: "Veiledere",
        blog: "Bloggen vår",
        applyCode: "Bruk kampanjekode",
        support: "Kundesupport",
        about: "Om oss",
        apply: "Veileder? Søk her",
        privacy: "Personvern",
        terms: "Vilkår",
    },
    wallet: {
        title: "Kjøp ringeminutter",
        intro:
            "Minutter lagres i din Mystic‑wallet og kan brukes hos alle veiledere (chat / samtale / video).",
        numLabel: "Telefonnummeret du ringer fra",
        amount: "Velg beløp",
        buy: (amt: number) => `Kjøp ${money(amt)} kreditt`,
        learn: "Les mer om betalingsmåter",
        err: "Skriv inn et gyldig telefonnummer",
        otp: (n: string) => `Kode sendt til ${n}. Skriv den inn for å bekrefte.`,
        enterOtp: "Skriv inn kode",
        verify: "Bekreft & legg til kreditt",
        cancel: "Avbryt",
        success: (amt: number) => `${money(amt)} lagt til i lommeboken!`,
        pm1: "Vipps MobilePay",
        pm2: "Kort (krever registrering på ditt mobilnummer)",
        nolgin: "Ingen innlogging nødvendig for Vipps MobilePay – ring direkte.",
    },
};
export default function VilkarPage({ currentUser, onLogout, baseUrl, onLoginClick, onLoginSuccess }: vilkarPageProps) {
    const [wallet, setWallet] = useState(0);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        if (currentUser?.role === "customer") {
            axios.get(baseUrl + "/getCustomerWallet", { params: { token: currentUser.token } })

                .then((response) => {
                    if (response.data.status === "OK") {
                        setWallet(response.data.data.remaining_amount);
                    }
                });
        }
    }, [currentUser, baseUrl])
    return (
        <div className={"bg-white text-gray-900"}>
            <Header wallet={wallet} scrolled={scrolled} T={T} onLoginClick={onLoginClick} currentUser={currentUser} onLogout={onLogout} baseUrl={baseUrl} />
            <main className="min-h-screen bg-gray-50 text-gray-800 py-16 px-6 md:px-12 lg:px-24">
                <div className="max-w-4xl mx-auto bg-white shadow-md rounded-2xl p-10">
                    <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6 text-center">
                        Vilkår for leveranser og bruk av Chamcore Technologies-plattformen
                    </h1>
                    <p className="text-gray-600 text-center mb-10">
                        Sist oppdatert: 11. november 2025
                    </p>

                    <section className="space-y-6 leading-relaxed">
                        <p>
                            Disse vilkårene regulerer bruk av Chamcore Technologies-plattformen og de tjenester som tilbys av uavhengige leverandører via plattformen.
                            Chamcore Technologies fungerer som en teknologisk formidler og tilrettelegger for kommunikasjon, betaling og levering av tjenester
                            mellom tilbyder og sluttkunde. Chamcore Technologies er ikke part i avtalen mellom tilbyder og kunde, men leverer infrastrukturen for
                            gjennomføring, betaling og sanntidsleveranser.
                        </p>

                        <h2 className="text-2xl font-bold text-gray-900 mt-10">1. Generelt</h2>
                        <p>
                            Ved å benytte Chamcore Technologies-plattformen aksepterer du disse vilkårene. Hver tilbyder på plattformen opererer selvstendig, og står juridisk
                            ansvarlig for sine egne leveranser, tjenester og kundebehandling. Chamcore Technologies tilrettelegger for sanntidstjenester, men kan ikke holdes
                            ansvarlig for eventuelle avbrudd, forsinkelser eller feil som skyldes tredjepart eller leverandørens systemer.
                        </p>

                        <h2 className="text-2xl font-bold text-gray-900 mt-10">2. Bestilling og levering</h2>
                        <p>
                            Tjenester bestilles direkte via plattformen, og leveres enten digitalt i sanntid eller etter nærmere avtale med leverandøren.
                            Kunden er selv ansvarlig for å oppgi korrekt kontaktinformasjon. Bekreftelse på bestilling sendes umiddelbart via e-post, SMS eller oppdateres i «Min bruker»-oversikten, avhengig av innstillingene valgt av brukeren.
                        </p>

                        <h2 className="text-2xl font-bold text-gray-900 mt-10">3. Betaling og transaksjonssikkerhet</h2>
                        <p>
                            Alle betalinger håndteres via Chamcore Technologies sine sikre betalingspartnere. Chamcore Technologies lagrer ikke kortinformasjon, utover de fire siste sifrene
                            som brukes for identifikasjon. Transaksjoner gjennomføres via sertifiserte betalingsleverandører (for eksempel Vipps, Stripe eller PayPal), i tråd med internasjonale sikkerhetsstandarder (PCI DSS).

                            For å legge til og bekrefte et betalingskort kreves sterk kundeautentisering (SCA) med to-faktorverifikasjon. I Norden skjer dette normalt gjennom BankID. Kunden kan velge å lagre sine betalingskort hos kortleverandøren for fremtidige kjøp. Dette muliggjør forenklede leveranser og betalinger, inkludert belastninger av kort under telefonsamtaler (IVR) der kunden selv godkjenner kjøpet.
                        </p>

                        <h2 className="text-2xl font-bold text-gray-900 mt-10">4. Angrerett og reklamasjon</h2>
                        <p>
                            Tjenester levert i sanntid er unntatt angrerettloven, jf. angrerettloven §22 bokstav n, som omhandler leveranser av digitalt innhold som tas i bruk umiddelbart etter kjøp. Ved å gjennomføre kjøpet samtykker kunden til at leveransen kan starte umiddelbart og fraskriver seg dermed angreretten.

                            Dersom tjenesten ikke er levert som avtalt, skal kunde kontakte den aktuelle leverandøren direkte for reklamasjon eller feilretting i henhold til forbrukerkjøpsloven. Chamcore Technologies har intet ansvar for manglende eller feilaktig leveranse, og skal holdes fullt ut skadesløs i slike tilfeller.
                        </p>

                        <h2 className="text-2xl font-bold text-gray-900 mt-10">5. Tilbydernes ansvar</h2>
                        <p>
                            Hver tilbyder på Chamcore Technologies-plattformen er selvstendig næringsdrivende, og står juridisk og økonomisk ansvarlig for innhold, kvalitet
                            og levering av sine tjenester. Tilbyder plikter å følge gjeldende lover, herunder markedsføringsloven, angrerettloven, bokføringsloven
                            og personvernlovgivningen (GDPR).
                        </p>

                        <h2 className="text-2xl font-bold text-gray-900 mt-10">6. Chamcore Technologies sitt ansvar</h2>
                        <p>
                            Chamcore Technologies leverer plattformen «som den er» uten garantier for tilgjengelighet, feilfrihet eller kontinuerlig drift. Chamcore Technologies kan ikke
                            holdes ansvarlig for direkte eller indirekte tap som følge av tekniske feil, avbrudd eller forhold utenfor vår kontroll. Chamcore Technologies
                            tilrettelegger for sikker kommunikasjon og betaling, men har ikke ansvar for innhold eller kvalitet på leverte tjenester.
                        </p>

                        <h2 className="text-2xl font-bold text-gray-900 mt-10">7. Behandling av personopplysninger</h2>
                        <p>
                            Personopplysninger behandles i samsvar med vår <a href="/personvern" className="text-blue-600 underline">personvernerklæring</a>.
                            Chamcore Technologies lagrer kun nødvendig informasjon for å kunne gjennomføre bestillinger og betalinger. Alle data behandles i tråd med GDPR. Les mer i vår <a href='/personvern' className='text-blue-600 underline'>fullstendige personvernerklæring</a> for detaljer om databehandling og brukerrettigheter.
                        </p>

                        <h2 className="text-2xl font-bold text-gray-900 mt-10">8. Endringer i vilkårene</h2>
                        <p>
                            Chamcore Technologies forbeholder seg retten til å oppdatere eller endre disse vilkårene ved behov. Gjeldende versjon publiseres alltid på våre
                            nettsider. Vesentlige endringer varsles i god tid før de trer i kraft.
                        </p>

                        <div className="mt-12 border-t pt-6 text-center text-sm text-gray-600">
                            <p>© {new Date().getFullYear()} Chamcore Technologies. Alle rettigheter forbeholdt.</p>
                        </div>
                    </section>
                </div>
            </main>
            <Footer baseUrl={baseUrl} />
        </div>
    );
}
